export const QUERY_FUNDS_API_URL =
  "https://get-receiver-cisn3inbwq-uc.a.run.app";
export const REQUEST_FUNDS_API_URL =
  "https://request-funds-cisn3inbwq-uc.a.run.app";
export const EXPLORER_BASE_URL = "https://optimistic.etherscan.io";
